<template>
	<div
		class="right check_col check_col1 m_toggle"
		v-bind:class="{
			col_done: !(this.$store.state.checkoutStage === 'info'),
			active: $mq == 'mobile',
		}"
	>
		<h2 class="check_title" onclick="mobileToggle(this)">
			הפרטים שלך
			<USERSTROKE />
			<span class="ok-svg">
				<OK />
			</span>
			<span class="check_col_plus"></span>
		</h2>

		<div class="check_col_inner m_toggleInner" :style="{ display: $mq == 'mobile' ? 'block' : '' }">
			<div class="group fields_open" :class="{ hide: !showOpenEdits, hasDiffAddress: showOtherAddress }">
				<div class="title_s">פרטים אישיים</div>
				<div class="clearfix">
					<div class="right wrap_input">
						<div class="form_tx">
							שם פרטי
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-model="address_firstname"
								v-validate="{ required: true }"
								name="billing_first_name"
								key="billing_first_name"
								@input="inputChanged($event, 'address_firstname')"
							/>
							<div class="error_tx" v-if="errors.first('billing_first_name')">
								{{ errors.first("billing_first_name") }}
							</div>
						</div>
					</div>
					<div class="left wrap_input">
						<div class="form_tx">
							שם משפחה
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-model="address_lastname"
								v-validate="{ required: true }"
								name="billing_last_name"
								key="billing_last_name"
								@input="inputChanged($event, 'address_lastname')"
							/>
							<div class="error_tx" v-if="errors.first('billing_last_name')">
								{{ errors.first("billing_last_name") }}
							</div>
						</div>
					</div>
				</div>

				<div class="clearfix" v-if="!userLogged || userCheckoutInfo.newUser">
					<div class="right wrap_input">
						<div class="form_tx">
							מייל
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								data-validation="email"
								v-validate="'required|email'"
								v-model="address_email"
								name="billing_email"
								key="billing_email"
								ref="address_email"
								v-on:blur="emailBlur"
								v-on:input="emailInput"
								@input="inputChanged($event, 'address_email')"
							/>
							<div class="error_tx" v-if="errors.first('billing_email')">
								{{ errors.first("billing_email") }}
							</div>
						</div>
					</div>
					<div class="left wrap_input">
						<div class="form_tx">
							ושוב פעם מייל
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								data-validation="email"
								v-model="address_email2"
								v-validate="'required|email|confirmed:address_email'"
								name="billing_email_confirm"
								key="billing_email_confirm"
								v-on:blur="emailBlur"
								v-on:input="emailInput"
								@input="inputChanged($event, 'address_email2')"
							/>
							<div class="error_tx" v-if="errors.first('billing_email_confirm')">
								{{ errors.first("billing_email_confirm") }}
							</div>
						</div>
					</div>
				</div>

				<div class="clearfix" v-if="!userExists && (!userLogged || userCheckoutInfo.newUser)">
					<div class="form_tx">
						סיסמה
						<span class="red">*</span>
					</div>
					<div class="form_input">
						<input
							type="password"
							v-validate="'required|min:6'"
							name="account_password"
							key="account_password"
							placeholder="יש לבחור סיסמה (6 תווים לפחות)"
						/>
						<div class="error_tx" v-if="errors.first('account_password')">
							{{ errors.first("account_password") }}
						</div>
					</div>
				</div>
				<div class="clearfix" v-if="userLogged && reg_via != 'website' && !userCheckoutInfo.newUser">
					<div class="form_tx">
						מייל
						<span class="red">*</span>
					</div>
					<div class="form_input">{{ address_email }}</div>
				</div>
				<div class="clearfix">
					<div class="right wrap_input">
						<div class="form_tx">
							טלפון
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-model="address_phone"
								v-validate="{
									required: true,
									regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
								}"
								data-validation="phone"
								name="billing_phone"
								key="billing_phone"
								@input="inputChanged($event, 'address_phone')"
							/>
							<div class="error_tx" v-if="errors.first('billing_phone')">
								{{ errors.first("billing_phone") }}
							</div>
						</div>
					</div>
					<div class="left wrap_input">
						<div class="form_tx">טלפון נוסף</div>
						<div class="form_input">
							<input
								type="text"
								v-model="address_phone2"
								v-validate="{
									regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
								}"
								data-validation="phone"
								name="billing_phonesec"
								key="billing_phonesec"
								@input="inputChanged($event, 'address_phone2')"
							/>
							<div class="error_tx" v-if="errors.first('billing_phonesec')">
								{{ errors.first("billing_phonesec") }}
							</div>
						</div>
					</div>
				</div>

				<!-- Company fields -->
				<div class="clearfix">
					<div class="form_tx">
						סוג לקוח
						<span class="red">*</span>
					</div>
					<div class="form_select">
						<Select2
							name="customer_type"
							v-validate="'required'"
							v-model="customer_type"
							key="customer_type"
							:placeholder="'סוג לקוח'"
							:searchable="false"
							@input="inputChanged($event, 'customer_type')"
						>
							<option value="regular" selected>פרטי</option>
							<option value="business">בית עסק</option>
						</Select2>
					</div>
				</div>
				<div class="clearfix" v-if="customer_type === 'business'">
					<div class="right wrap_input">
						<div class="form_tx">
							שם בית העסק
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-model="business_name"
								v-validate="{ required: true }"
								name="business_name"
								key="business_name"
								@input="inputChanged($event, 'business_name')"
							/>
							<div class="error_tx" v-if="errors.first('business_name')">
								{{ errors.first("business_name") }}
							</div>
						</div>
					</div>
					<div class="left wrap_input">
						<div class="form_tx">
							ח.פ / ת.ז
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-model="business_tax_id"
								v-validate="{ required: true }"
								name="business_tax_id"
								key="business_tax_id"
								@input="inputChanged($event, 'business_tax_id')"
							/>
							<div class="error_tx" v-if="errors.first('business_tax_id')">
								{{ errors.first("business_tax_id") }}
							</div>
						</div>
					</div>
				</div>
				<!-- END OF | Company fields -->

				<BirthdayField v-if="showInnerBirthday && (!userLogged || !userCheckoutInfo.birthday)"/>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits">
				<div class="title_s relative">
					פרטים אישיים
					<a href="javascript:void(0)" @click="toggleEditInputs" class="edit_link">
						ערוך פרטים
						<PEN />
					</a>
				</div>
				<div class="text" v-html="userDetails"></div>
				<div class="birthday-warp" v-if="(!userLogged || !userCheckoutInfo.birthday) && this.$store.state.checkoutStage === 'info'">
					<hr/>
					<BirthdayField/>
				</div>
				<hr />
			</div>

			<div class="group fields_open" :class="{ hide: !showOpenEditShipping }" v-if="!showOtherAddress">
				<div class="shipping-method">
					<div class="title_s">אופן משלוח</div>
					<div class="clearfix">
						<div class="radio_choose">
							<label class="form_check form_radio">
								<div class="form_check_tx">
									משלוח עד הבית
									<input
										type="radio"
										name="order_shipping_method"
										v-model="shipping_method"
										value="flat_rate"
										@change="inputChanged($event, 'shipping_method')"
									/>
									<span class="checkmark"></span>
								</div>
							</label>
							<label class="form_check form_radio">
								<div class="form_check_tx">
									איסוף עצמי
									<input
										type="radio"
										name="order_shipping_method"
										v-model="shipping_method"
										value="local_pickup"
										@change="inputChanged($event, 'shipping_method')"
									/>
									<span class="checkmark"></span>
									<span class="shipping-price"> - <span>חינם!</span></span>
								</div>
							</label>
						</div>
					</div>
				</div>

				<div class="shipping-details" :class="{ hidden: isLocalPickUp }">
					<div class="title_s">כתובת למשלוח</div>
					<div class="clearfix">
						<div class="form_tx">
							עיר
							<span class="red">*</span>
						</div>
						<div class="form_select">
							<select2
								name="billing_city"
								v-validate="'required'"
								v-model="address_city"
								key="billing_city"
								:placeholder="'בחר עיר מהרשימה'"
								@input="inputChanged($event, 'address_city')"
							>
								<option></option>
								<option :value="city.city_name" v-for="city in cities" :key="city.id">
									{{ city.city_name }}
								</option>
							</select2>
							<div class="error_tx" v-if="errors.first('billing_city')">
								{{ errors.first("billing_city") }}
							</div>
						</div>
					</div>
					<div class="clearfix">
						<div class="right wrap_input field-street">
							<div class="form_tx">
								רחוב
								<span class="red">*</span>
							</div>
							<div v-if="no_street && !isLocalPickUp" class="no-street">
								במידה וכתובתך לא נמצאה יש לבחור "ללא רחוב"
							</div>
							<div class="form_input">
								<vue-simple-suggest
									ref="streets"
									preventHide="true"
									v-model="address_street"
									:list="getStreets"
									:class="{ proccessing: loadingStreets }"
									mode="input"
									:debounce="500"
									value-attribute="name"
									:min-length="1"
									autocomplete="off"
									:controls="{
										selectionUp: [38],
										selectionDown: [40],
									}"
									display-attribute="name"
									:prevent-submit="true"
									:destyled="true"
									v-validate="{ required: true }"
									name="billing_address_street"
									key="billing_address_street"
									@select="onAddressSelect"
									@input="inputChanged($event, 'address_street')"
									@blur="onBlur"
								>
									<input
										type="text"
										:value="address_street"
										autocomplete="off"
										v-validate="{ required: true }"
										name="billing_address_street"
										key="billing_address_street"
									/>
									<div slot="suggestion-item" slot-scope="{ suggestion }" class="custom">
										<div class="clearfix">
											<span class="right autoc_tx">
												<span
													class="pr_title street_name_label"
													v-html="suggestion.label"
												></span>
												<button
													@click="addCityInput()"
													class="small_rounded_button"
													v-if="suggestion.value == 'addstreet'"
												>
													+
												</button>
											</span>
										</div>
									</div>
								</vue-simple-suggest>
								<div class="error_tx" v-if="errors.first('billing_address_street')">
									{{ errors.first("billing_address_street") }}
								</div>
								<div class="error-not-from-list" v-if="showAdressError">
									כדי שנגיע אליכם הכי מהר שאפשר מומלץ לבחור כתובת מהרשימה...
								</div>
							</div>
						</div>
						<div class="left wrap_input field-house-number">
							<div class="form_tx">
								מס' בית
								<span class="red">*</span>
							</div>
							<div class="form_input">
								<input
									type="text"
									v-model="address_house"
									v-validate="'required'"
									name="billing_address_house"
									key="billing_address_house"
									@input="inputChanged($event, 'address_house')"
								/>
								<div class="error_tx" v-if="errors.first('billing_address_house')">
									{{ errors.first("billing_address_house") }}
								</div>
							</div>
						</div>
					</div>
					<div class="clearfix" :class="{ hidden: isLocalPickUp }">
						<div class="right small_input field-apartment-number">
							<div class="form_tx">דירה <span class="red">*</span></div>
							<div class="form_input">
								<input
									type="text"
									v-model="address_apart"
									name="billing_address_apart"
									v-validate="'required'"
									key="billing_address_apart"
									@input="inputChanged($event, 'address_apart')"
								/>
								<div class="error_tx" v-if="errors.first('billing_address_apart')">
									{{ errors.first("billing_address_apart") }}
								</div>
							</div>
						</div>
						<div class="right small_input field-floor-number">
							<div class="form_tx">קומה <span class="red">*</span></div>
							<div class="form_input">
								<input
									type="text"
									v-model="address_floor"
									name="billing_address_floor"
									v-validate="'required'"
									key="billing_address_floor"
									@input="inputChanged($event, 'address_floor')"
								/>
								<div class="error_tx" v-if="errors.first('billing_address_floor')">
									{{ errors.first("billing_address_floor") }}
								</div>
							</div>
						</div>
						<div class="right small_input field-entrance-code">
							<div class="form_tx">קוד כניסה</div>
							<div class="form_input">
								<input
									type="text"
									v-model="address_code"
									name="billing_address_code"
									@input="inputChanged($event, 'address_code')"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="local-pickup-notice" :class="{ hidden: !isLocalPickUp }">
					<div>איסוף עצמי ממרלו"ג כרמלה</div>
					<strong>הסנדא 5, חולון</strong>
				</div>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits && !showOpenEditShipping">
				<div class="title_s relative">
					<div>{{ isLocalPickUp ? "כתובת לאיסוף" : "כתובת למשלוח" }}</div>
					<a href="javascript:void(0)" @click="toggleEditInputs" class="edit_link">
						ערוך פרטים
						<PEN />
					</a>
				</div>
				<div class="text" v-html="userAddress.replace('קומה 0, דירה 0', '').replace(' -', ',')"></div>
			</div>

			<div
				class="green_link other_add_link"
				v-if="!this.$store.state.createPermenantOrder"
				style="display: block"
				v-bind:class="{ hasDiffAddress: showOtherAddress, hidden: isLocalPickUp }"
			>
				<a href="javascript:void(0);" @click="openOtherAddress">
					<span v-if="!showOtherAddress">+</span>
					<span v-if="showOtherAddress">- בטל</span>&nbsp; הזמנה לכתובת אחרת באופן חד פעמי
				</a>
			</div>
			<div class="group fields_open" v-bind:class="{ hide: !showOpenEdits }" v-if="showOtherAddress">
				<input
					id="ship-to-different-address-checkbox"
					type="hidden"
					name="ship_to_different_address"
					value="1"
				/>
				<div class="title_s">פרטי הנמען</div>
				<div class="clearfix">
					<div class="right wrap_input">
						<div class="form_tx">
							שם פרטי
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-validate="{ required: true }"
								v-model="shipping_first_name"
								name="shipping_first_name"
								key="shipping_first_name"
							/>
							<div class="error_tx" v-if="errors.first('shipping_first_name')">
								{{ errors.first("shipping_first_name") }}
							</div>
						</div>
					</div>
					<div class="left wrap_input">
						<div class="form_tx">
							שם משפחה
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-validate="{ required: true }"
								v-model="shipping_last_name"
								name="shipping_last_name"
								key="shipping_last_name"
							/>
							<div class="error_tx" v-if="errors.first('shipping_last_name')">
								{{ errors.first("shipping_last_name") }}
							</div>
						</div>
					</div>
				</div>
				<div class="clearfix">
					<div class="right wrap_input">
						<div class="form_tx">
							טלפון
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-model="shipping_phone"
								v-validate="{
									required: true,
									regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
								}"
								data-validation="phone"
								name="shipping_phone"
								key="shipping_phone"
							/>
							<div class="error_tx" v-if="errors.first('shipping_phone')">
								{{ errors.first("shipping_phone") }}
							</div>
						</div>
					</div>
					<div class="left wrap_input">
						<div class="form_tx">טלפון נוסף</div>
						<div class="form_input">
							<input
								type="tel"
								v-model="shipping_phone2"
								v-validate="{
									regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
								}"
								data-validation="phone"
								name="shipping_phonesec"
								key="shipping_phonesec"
							/>
							<div class="error_tx" v-if="errors.first('shipping_phonesec')">
								{{ errors.first("shipping_phonesec") }}
							</div>
						</div>
					</div>
				</div>
				<div class="clearfix">
					<div class="form_tx">
						עיר
						<span class="red">*</span>
					</div>
					<div class="form_select">
						<select2
							name="shipping_city"
							v-validate="'required'"
							v-model="shipping_city"
							key="shipping_city"
							:placeholder="'בחר עיר מהרשימה'"
						>
							<option></option>
							<option :value="city.city_name" v-for="city in cities" :key="city.id">
								{{ city.city_name }}
							</option>
						</select2>
						<div class="error_tx" v-if="errors.first('shipping_city')">
							{{ errors.first("shipping_city") }}
						</div>
					</div>
				</div>
				<div class="clearfix">
					<div class="right wrap_input">
						<div class="form_tx">
							רחוב
							<span class="red">*</span>
						</div>
						<div v-if="no_street" class="no-street">במידה וכתובתך לא נמצאה יש לבחור "ללא רחוב"</div>
						<div class="form_input">
							<vue-simple-suggest
								ref="streets"
								v-model="shipping_street"
								:class="{ proccessing: loadingStreets }"
								:list="getStreets"
								mode="input"
								autocomplete="off"
								:min-length="1"
								value-attribute="name"
								:controls="{
									selectionUp: [38],
									selectionDown: [40],
								}"
								display-attribute="name"
								:prevent-submit="true"
								:destyled="true"
								@select="onAddressSelect"
							>
								<input
									type="text"
									autocomplete="off"
									v-validate="{ required: true }"
									name="shipping_address_street"
									:value="shipping_street"
									key="shipping_address_street"
									@blur="checkAddress"
								/>
								<div
									slot="suggestion-item"
									:data-hover="suggestion.id"
									slot-scope="{ suggestion }"
									class="custom"
								>
									<div class="clearfix">
										<span class="right autoc_tx">
											<span class="pr_title street_name_label" v-html="suggestion.label"></span>
											<button
												@click="addCityInput()"
												class="small_rounded_button"
												v-if="suggestion.value == 'addstreet'"
											>
												+
											</button>
										</span>
									</div>
								</div>
							</vue-simple-suggest>
							<div class="error_tx" v-if="errors.first('shipping_address_street')">
								{{ errors.first("shipping_address_street") }}
							</div>
							<div class="error-not-from-list" v-if="showAdressError">
								כדי שנגיע אליכם הכי מהר שאפשר מומלץ לבחור כתובת מהרשימה...
							</div>
						</div>
					</div>
					<div class="left wrap_input">
						<div class="form_tx">
							מס' בית
							<span class="red">*</span>
						</div>
						<div class="form_input">
							<input
								type="text"
								v-validate="'required'"
								name="shipping_address_house"
								v-model="shipping_house"
								key="shipping_address_house"
							/>
							<div class="error_tx" v-if="errors.first('shipping_address_house')">
								{{ errors.first("shipping_address_house") }}
							</div>
						</div>
					</div>
				</div>
				<div class="clearfix">
					<div class="right small_input">
						<div class="form_tx">דירה <span class="red">*</span></div>
						<div class="form_input">
							<input
								type="text"
								v-model="shipping_apart"
								name="shipping_address_apart"
								v-validate="'required'"
								key="shipping_address_apart"
							/>
							<div class="error_tx" v-if="errors.first('shipping_address_apart')">
								{{ errors.first("shipping_address_apart") }}
							</div>
						</div>
					</div>
					<div class="right small_input">
						<div class="form_tx">קומה <span class="red">*</span></div>
						<div class="form_input">
							<input
								type="text"
								v-model="shipping_floor"
								name="shipping_address_floor"
								v-validate="'required'"
								key="shipping_address_floor"
							/>
							<div class="error_tx" v-if="errors.first('shipping_address_floor')">
								{{ errors.first("shipping_address_floor") }}
							</div>
						</div>
					</div>
					<div class="right small_input">
						<div class="form_tx">קוד כניסה</div>
						<div class="form_input">
							<input type="text" v-model="shipping_code" name="shipping_address_code" />
						</div>
					</div>
				</div>
				<hr />
				<div class="clearfix title_s_wrap">
					<div class="right title_s inline">הזמנת מתנה</div>
					<div class="right wrap_tooltip">
						<div
							class="type_info hasTooltip"
							title="איזה כיף של מתנה! אפשר להוסיף ברכה או הקדשה ואם זו תרומה לאדם או עמותה אנחנו אתך! לא נגבה דמי משלוח"
						>
							?
						</div>
					</div>
				</div>
				<div class="clearfix">
					<div class="form_tx">כתוב ברכה / הקדשה</div>
					<div class="form_input">
						<textarea v-model="greetings" name="greetings"></textarea>
						<!--<input
              type="text"
              v-model="greetings"
              name="greetings"
            />-->
					</div>
				</div>
			</div>
			<div class="group fields_close" v-if="!showOpenEdits && hasGiftDonation && showOtherAddress">
				<div class="title_s relative">
					הזמנת מתנה / תרומה
					<a href="javascript:void(0)" @click="toggleEditInputs" class="edit_link">
						ערוך פרטים
						<PEN />
					</a>
				</div>
				<div class="text" v-html="greetings" v-if="showOtherAddress"></div>
				<div class="text" v-if="donation">הזמנה זו היא תרומה</div>
			</div>

			<div class="bt_green ease">
				<a href="javascript:void(0);" @click="checkAddress()" class="info-checkout loading-button">
					{{ !isLocalPickUp ? "לתיאום המשלוח" : "לתיאום איסוף" }}
					<span class="loader">
						<img
							:src="
								wpData.CARMELLA_CDN_ROOT_URL + '/wp-content/themes/carmella/assets/img/svg/loader.svg'
							"
						/>
					</span>
				</a>
			</div>
		</div>

		<OfficeCoreCoordinates />
	</div>
</template>
<script>
	import axios from "axios";
	import OfficeCoreCoordinates from "./OfficeCoreCoordinates.vue";
	import OK from "../../assets/img/ok.svg";
	import USERSTROKE from "../../assets/img/user-stroke.svg";
	import PEN from "../../assets/img/pen.svg";
	import Select2 from "../Select2";
	import VueSimpleSuggest from "vue-simple-suggest/dist/cjs";
	import BirthdayField from "./BirthdayField.vue";
	import { mapState, mapActions, mapGetters } from "vuex";

	export default {
		data() {
			return {
				wpData: window.wpData,
				require_coordinates: window.wpData.globalOptions.office_core_settings.require_coordinates,
				editInputs: true,
				userEditInputs: false,
				activeStep: this.$store.state.checkoutStage,
				selectedHour: false,
				showErrors: false,
				infoEdit: true,
				shipEdit: true,
				loadingStreets: false,
				continueEnter: false,
				showOtherAddress: false,
				couponcode: "",
				all_ok: false,
				add_city: false,
				no_street: false,
				//product_open_note:"",
				couponNoteStatus: 0,
				//address_firstname: this.$store.state.userLogged ? this.$store.getters.userCheckoutInfo.firstname : this.$store.state.formFields.address_firstname,
				address_firstname: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.firstname
					: this.$store.getters.formFields("address_firstname"),
				address_lastname: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.lastname
					: this.$store.getters.formFields("address_lastname"),
				address_email: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.email
					: this.$store.getters.formFields("address_email"),
				address_email2: this.$store.state.userLogged ? "" : this.$store.getters.formFields("address_email2"),
				address_phone: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.phone
					: this.$store.getters.formFields("address_phone"),
				address_phone2: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.phonesec
					: this.$store.getters.formFields("address_phone2"),
				address_notes: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.notes
					: this.$store.getters.formFields("address_notes"),
				address_city: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.city
					: this.$store.getters.formFields("address_city"),
				address_street: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.street
					: this.$store.getters.formFields("address_street"),
				address_house: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.house
					: this.$store.getters.formFields("address_house"),
				address_floor: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.floor
					: this.$store.getters.formFields("address_floor"),
				address_apart: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.apart
					: this.$store.getters.formFields("address_apart"),
				address_code: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.code
					: this.$store.getters.formFields("address_code"),
				showInnerBirthday: !this.showOpenEdits,

				reg_via: this.$store.state.userLogged ? this.$store.getters.userCheckoutInfo.regvia : "",
				shipping_city: "",
				shipping_first_name: "",
				shipping_last_name: "",
				shipping_email: "",
				shipping_street: "",
				shipping_house: "",
				shipping_phone: "",
				shipping_apart: "",
				shipping_floor: "",
				shipping_code: "",
				shipping_phone2: "",
				shipping_method: this.isLocalPickUp ? 'local_pickup' : 'flat_rate',
				greetings: "",
				donation: false,
				streets: [],
				userExists: false,

				// Company
				customer_type:
					this.$store.state.userLogged &&
					typeof this.$store.getters.userCheckoutInfo.customer_type != "undefined"
						? this.$store.getters.userCheckoutInfo.customer_type
						: this.$store.getters.formFields("customer_type")
						? this.$store.getters.formFields("customer_type")
						: "regular",
				business_name: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.business_name
					: this.$store.getters.formFields("business_name"),
				business_tax_id: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.business_tax_id
					: this.$store.getters.formFields("business_tax_id"),

				address: "",
				cityLatLng: false,
				cityBounds: false,
				showAdressError: false,
				shippingMethod_prevCity: this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.city
					: this.$store.getters.formFields("address_city"),
				shipmentCost: wpData.shipment_cost,
				showOpenEditShipping: true,
			};
		},
		methods: {
			...mapActions(["getShipSlots"]),
			// checkAddress(e) {
			//   this.showAdressError = false;
			//   if (this.address_city !== 'איסוף עצמי' && e.target.value !== '' && e.target.value !== this.address) {
			//     this.showAdressError = true;
			//   }
			// },
			googleAPI_city() {
				const service = new google.maps.Geocoder();
				service.geocode(
					{
						address: this.showOtherAddress ? this.shipping_city : this.address_city,
					},
					(results, status) => {
						if (status !== "OK") {
							console.log("Geocode was not successful for the following reason: " + status);
						}
						// console.log(results[0]);
						if (results != null) {
							this.cityLatLng = results[0].geometry.location;
							this.cityBounds = results[0].geometry.bounds;
						}
					}
				);
			},
			googleAPI_streets(input) {
				const service = new google.maps.places.AutocompleteService();
				return new Promise((resolve, reject) => {
					service.getPlacePredictions(
						{
							//input: this.address_city + ", " + this.address_street,
							input: this.showOtherAddress
								? this.shipping_city + ", " + this.shipping_street
								: this.address_city + ", " + this.address_street,
							componentRestrictions: {
								country: "il",
							},
							bounds: this.cityBounds,
							// location: this.cityLatLng,
							// radius: 10,
							types: ["route"],
						},
						(predictions, status) => {
							if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
								reject();
							}
							resolve(predictions);
						}
					);
				});
			},
			getStreets() {
				return new Promise((resolve, reject) => {
					this.loadingStreets = true;
					let shipping = false;
					if (this.showOtherAddress) {
						shipping = true;
					}
					this.add_city = false;
					this.no_street = false;
					let output = [];

					this.googleAPI_streets()
						.then((streets) => {
							console.log("streets: ", streets);
							this.loadingStreets = false;

							streets.forEach((value) => {
								//if (typeof value.terms[1] !== 'undefined' && value.terms[1].value.includes(this.address_city)) {
								if (
									typeof value.structured_formatting.secondary_text !== "undefined" &&
									value.structured_formatting.secondary_text.includes(
										this.showOtherAddress ? this.shipping_city : this.address_city
									)
								) {
									// console.log(value.structured_formatting.secondary_text);
									// console.log(this.address_city);

									let street = value.structured_formatting.main_text;
									if (!/^\d+$/.test(street) && !street.includes("סמטה")) {
										street = street.replace(/\d+/g, "");
									}

									output.push({
										name: street,
										label: street,
										value: street,
									});
								}
							});

							if (!output.length) {
								output.push({
									name: "ללא רחוב",
									label: "ללא רחוב",
									value: "ללא רחוב",
								});
							}

							resolve(output);
						})
						.catch(() => {
							this.loadingStreets = false;
							console.log("no results");
							this.no_street = true;
							output.push({
								name: "ללא רחוב",
								label: "ללא רחוב",
								value: "ללא רחוב",
							});
							resolve(output);
						});

					// if (streets.length == 1 && streets[0].value == "addstreet") {
					//   streets[0].name = shipping ? this.shipping_street : this.address_street;
					// }
				});
			},
			addCityInput() {
				this.add_city = false;
				this.$refs.streets.hideList();
			},
			onAddressSelect(value) {
				if (value.value == "addstreet") {
					value.value = this.address_street;
					return;
				}
				this.address = value.value;
				this.showAdressError = false;
				this.$refs.streets.hideList();
				this.no_street = false;
				this.toggleNoAddress();
			},
			toggleEditInputs() {
				this.editInputs = true;
				this.userEditInputs = true;
				this.showOpenEditShipping = true;
				this.$store.commit("changeCheckoutStage", "info");
				this.$root.$emit("stage-complete", 0);
				this.showInnerBirthday = true;
			},
			toggleInfo() {
				this.infoEdit = true;
				this.shipEdit = true;
				this.$store.commit("changeCheckoutStage", "info");
				this.$root.$emit("stage-complete", 0);
			},
			toggleShipment() {
				this.infoEdit = true;
				this.shipEdit = true;
				this.$store.commit("changeCheckoutStage", "info");
				this.$root.$emit("stage-complete", 0);
			},
			changeTab(tab) {
				this.showInnerBirthday = true;
				this.$validator.validate().then((result) => {
					if (result) {
						// do stuff if valid.
						this.checkUserEmail()
							.then((res) => {
								if (res) {
									this.editInputs = false;
									this.userEditInputs = false;
									this.showOpenEditShipping = false;

									let city = this.checkoutCity;
									let find = this.cities.find((c) => c.city_name == city);
									let address = `${this.address_street} ${this.address_house} , ${this.checkoutCity} , ישראל`;

									if (
										this.$store.state.createPermenantOrder == "true" ||
										this.$store.state.createPermenantOrder
									) {
										this.getShipSlots([find.id, true]);
									} else {
										this.getShipSlots([find.id, false]);
									}
									this.$store.commit("changeCheckoutStage", tab);
									this.$root.$emit("stage-complete", 1);
									if (this.$mq == "mobile") {
										mobileToggle($(".check_col2 h2"));
										setTimeout(() => {
											const shipmentDomElement = document.querySelector(
												".right.check_col.check_col2.m_toggle"
											);
											shipmentDomElement.scrollIntoView({
												behavior: "smooth",
											});
										}, 300);
									}
									return;
								}
							})
							.catch((e) => {
								console.log(e);

								return;
							});
					}
					return;
				});
			},
			openOtherAddress() {
				this.toggleEditInputs();
				this.$root.$emit("removeOtherAddress", { flag: true });
				if (this.showOtherAddress) {
					this.showOtherAddress = false;
				} else {
					this.showOtherAddress = true;
					setTimeout(() => {
						this.$store.dispatch("initToolTip");
					}, 500);
				}
			},
			checkUserEmail() {
				return new Promise((resolve, reject) => {
					if (!this.$store.state.userLogged) {
						axios({
							method: "GET",
							url: ajaxUrl + "?action=check_user_email&email=" + this.address_email,
						}).then((response) => {
							this.userExists = false;
							this.$store.commit("checkoutUserExists", false);
							switch (response.data.return) {
								case "Error":
									const field = this.$validator.fields.find({
										name: "billing_email",
										scope: this.$options.scope,
									});
									if (!field) return;
									this.$validator.errors.add({
										id: field.id,
										field: "billing_email",
										msg: "כתובת דוא״ל קיימת במערכת",
										scope: this.$options.scope,
									});
									field.setFlags({
										invalid: true,
										valid: false,
										validated: true,
									});
									return resolve(false);

									break;
								case "emailExists":
									this.userExists = true;
									this.$store.commit("checkoutUserExists", true);
									return resolve(true);

									break;
								case "OK":
									return resolve(true);

									break;
							}
						});
						return;
					}

					return resolve(true);
				});
			},
			async checkAddress() {
				this.toggleNoAddress();
				const form_is_valid = await this.$validator.validate();
				if (!form_is_valid) return false;
				const button = document.querySelector(".info-checkout.loading-button");
				if (button.classList.contains("is-loading")) {
					return false;
				}

				// Handle coordinates
				let toCity, toStreet, toNumber;

				if (this.showOtherAddress && this.shipping_city) {
					// One time shipping
					toCity = this.shipping_city;
					toStreet = this.shipping_street;
					toNumber = this.shipping_house;
				} else {
					// Permanent address
					toCity = this.address_city;
					toStreet = this.address_street;
					toNumber = this.address_house;
				}

				const toAddress = toStreet + " " + toNumber + ", " + toCity;

				if (
					!this.$store.state.emergencyMode.officecore &&
					(toAddress !== this.$store.state.coordinates.address || !this.$store.state.coordinates.x)
				) {
					button.classList.add("is-loading");

					this.getCoordinates().then((r) => {
						if (r.success) {
							this.$store.state.coordinates.address = toAddress;
							this.$store.state.coordinates.x = r.coordinates.x;
							this.$store.state.coordinates.y = r.coordinates.y;
							try {
								window.dataLayer.push({
									event: "ga_event",
									category: "checkout",
									action: "get_coordinates",
									label: "success",
								});
							} catch (err) {}
						} else {
							this.$store.state.coordinates.x = "";
							this.$store.state.coordinates.y = "";
							this.$store.state.coordinates.address = toAddress;
							button.classList.remove("is-loading");

							try {
								window.dataLayer.push({
									event: "ga_event",
									category: "checkout",
									action: "get_coordinates",
									label: "failed",
								});
							} catch (er) {}

							// If coordinates are mandatory - block user from moving forward without coordinates
							if (this.require_coordinates) {
								this.$modal.show("office-core-coordinates-failed");
								return false;
							}
						}

						button.classList.remove("is-loading");
						this.changeTab("shippment");
					});
					return false;
				} else {
					this.changeTab("shippment");
				}
			},
			toggleNoAddress() {
				if (this.address_street == "ללא רחוב") {
					this.$validator.detach("billing_address_house");
					this.$validator.detach("billing_address_apart");
					this.$validator.detach("billing_address_floor");
					jQuery(
						".field-house-number, .field-floor-number, .field-apartment-number, .field-entrance-code"
					).hide();
					this.address_house = "";
					this.address_apart = "";
					this.address_floor = "";
					this.address_code = "";
				} else {
					this.$validator.attach("billing_address_house");
					this.$validator.attach("billing_address_apart");
					this.$validator.attach("billing_address_floor");
					jQuery(
						".field-house-number, .field-floor-number, .field-apartment-number, .field-entrance-code"
					).show();
				}
			},
			getCoordinates() {
				let city = this.shipping_city ? this.shipping_city : this.address_city;
				const street = this.shipping_street ? this.shipping_street : this.address_street;
				const number = this.shipping_house ? this.shipping_house : this.address_house;
				const userID = this.$store.getters.userCheckoutInfo.id;

				// Handle self pickup איסוף עצמי
				if (city === "איסוף עצמי") {
					city = "חולון";
				}

				return new Promise((resolve, reject) => {
					const saveToUser = !this.shipping_city;
					const url = `${ajaxUrl}?action=getCoordinates&city=${city}&street=${street}&number=${number}&saveToUser=${saveToUser}&userID=${userID}`;
					fetch(url)
						.then((raw) => raw.json())
						.then((res) => {
							resolve(res);
						})
						.catch((e) => {
							console.log(e);
							reject(e);
						});
				});
			},
			emailBlur() {
				const email1 = document.querySelector("[name='billing_email']").value;
				const email2 = document.querySelector("[name='billing_email_confirm']").value;
				if (email1 !== "" && email1 === email2) {
					this.checkUserEmail();
				}
			},
			emailInput() {
				this.$store.commit("checkoutUserExists", false);
				this.userExists = false;
			},
			inputChanged(e, name) {
				let value = typeof e === "object" ? e.target.value : e;
				this.$store.commit("setFormFields", { name: name, value: value });

				let formFields = localStorage.getItem("formFields");
				formFields = formFields === null ? {} : JSON.parse(formFields);
				formFields[name] = value;
				localStorage.setItem("formFields", JSON.stringify(formFields));

				this.no_street = false;
				this.toggleNoAddress();

				if (name === "address_city") {
					this.$store.commit("setLocalPickup", e === "איסוף עצמי");
				}

				if (name === "shipping_method") {
					console.log("this.address_city", this.address_city);
					if (e.target.value === "local_pickup") {
						this.shippingMethod_prevCity = this.address_city;
						this.address_city = "איסוף עצמי";
						//this.shipping_city = 'איסוף עצמי';
						this.$store.commit("setLocalPickup", true);
					} else {
						this.address_city = this.shippingMethod_prevCity;
						this.$store.commit("setLocalPickup", false);
					}
					//this.isLocalPickUp;
				}
			},
			onBlur() {
				this.$refs.streets.hideList();
				console.log("selected", this.$refs.streets.selected);

				if (!this.$refs.streets.selected || this.$refs.streets.selected.value !== this.address_street) {
					this.address_street = "";
				}

				this.no_street = false;
				this.toggleNoAddress();
			},
			setAddress() {
				// this.address_city = this.$store.state.userLogged
				//     ? this.$store.getters.userCheckoutInfo.city
				//     : this.$store.getters.formFields("address_city");
				this.address_street = this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.street
					: this.$store.getters.formFields("address_street");
				this.address_house = this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.house
					: this.$store.getters.formFields("address_house");
				this.address_floor = this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.floor
					: this.$store.getters.formFields("address_floor");
				this.address_apart = this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.apart
					: this.$store.getters.formFields("address_apart");
				this.address_code = this.$store.state.userLogged
					? this.$store.getters.userCheckoutInfo.code
					: this.$store.getters.formFields("address_code");
			},
		},
		watch: {
			address_city: function (value) {
				this.$store.commit("setCity", value);
				// this.address_street = "";
				// this.address_house = "";
				// this.address_apart = "";
				if (this.isLocalPickUp) {
					this.address_street = "הסדנא";
					this.address_house = "5 - חולון";
					this.address_apart = "0";
					this.address_floor = "0";
					this.address_code = "";
					this.shipping_method = "local_pickup";
				} else {
					this.setAddress();
				}

				this.googleAPI_city();
			},
			shipping_city: function (value) {
				this.shipping_street = "";
				this.shipping_house = "";
				this.shipping_apart = "";
				if (this.isLocalPickUp) {
					this.shipping_street = "הסדנא - חולון";
					this.shipping_house = "5 - חולון";
					this.shipping_apart = "0";
					this.shipping_floor = "0";
					this.shipping_floor = "";
				}

				this.googleAPI_city();
			},
			donation: function (value) {
				this.$store.state.orderIsDonation = value;
			},
			showOtherAddress: function (newValue, oldValue) {
				if (oldValue && !newValue) {
					this.donation = false;
				}
			},
			isLocalPickUp: function (newValue, oldValue) {
				if (newValue === true) {
					this.address_city = "איסוף עצמי";
				}
			},
		},
		mounted() {
			let city = this.$store.getters.userCheckoutInfo.city
				? this.$store.getters.userCheckoutInfo.city
				: this.address_city;

			if (typeof this.orderEdit != "undefined" && this.orderEdit) {
				if (this.orderEdit.meta["shipping_first_name"][0] && this.orderEdit.meta["shipping_last_name"][0]) {
					this.showOtherAddress = true;
					this.shipping_first_name = this.orderEdit.meta["shipping_first_name"][0];
					this.shipping_last_name = this.orderEdit.meta["shipping_last_name"][0];
					this.shipping_city = this.orderEdit.meta["_shipping_city"][0];
					this.shipping_street = this.orderEdit.meta["shipping_street"][0];
					this.shipping_house = this.orderEdit.meta["shipping_house"][0];
					this.shipping_phone = this.orderEdit.meta["shipping_phone"][0];
					this.shipping_apart = this.orderEdit.meta["shipping_apart"][0];
					// this.greetings = this.orderEdit.meta['greetings'][0];
					city = this.shipping_city;
				}
			}

			if (city) {
				// console.log(city);
				this.googleAPI_city();
			}

			// Skip Info step if user is logged on
			// if (this.userLoggedInfo) {
			// 	this.changeTab("shippment");
			// }

			//this.isLocalPickUp;
			if (this.isLocalPickUp) {
				this.shipping_method = "local_pickup";
			}
		},
		computed: {
			...mapState(["cities", "userLoggedInfo"]),
			...mapGetters(["orderEdit", "userCheckoutInfo", "isLocalPickUp"]),
			showOpenEdits() {
				if (this.userLogged && !this.userEditInputs && this.address_city != "" && this.formTest) {
					return false;
				}
				if (!this.editInputs) {
					return false;
				}
				return true;
			},
			// isLocalPickUp() {
			// 	let city = this.cities.find((c) => c.city_name == this.address_city);
			// 	let shipping_city = this.cities.find((c) => c.city_name == this.shipping_city);
			//
			//   //console.log('city', city)
			// 	if (typeof city != "undefined" && city.local == "1") {
			// 		this.$store.commit("setLocalPickup", true);
			// 		return true;
			// 	}
			// 	if (typeof shipping_city != "undefined" && shipping_city.local == "1") {
			// 		this.$store.commit("setLocalPickup", true);
			// 		return true;
			// 	}
			// 	this.$store.commit("setLocalPickup", false);
			// 	return false;
			// },
			addressRegex() {
				return "/^[א-ת ]*$/";
			},
			checkoutCity() {
				if (!this.showOtherAddress) {
					return this.address_city;
				}
				return this.shipping_city;
			},
			hasGiftDonation() {
				if (this.greetings || this.donation) {
					return true;
				}
				return false;
			},
			formTest() {
				var valid = false;
				var fields = Object.values(this.fields);
				var valid = fields.find((field) => field.valid === false);
				if (valid) {
					return false;
				}
				return true;
			},
			userLogged() {
				if (this.$store.state.userLogged) {
					return true;
				}
				return false;
			},
			userDetails() {
				var str =
					this.address_firstname +
					" " +
					this.address_lastname +
					"<br />" +
					this.address_email +
					"<br />" +
					this.address_phone;

				if (this.address_phone2) {
					str = str + "<br />" + this.address_phone2;
				}

				if (this.customer_type === "business") {
					if (this.business_name) {
						str += "<br/>שם בית עסק: " + this.business_name;
					}
					if (this.business_tax_id) {
						str += "<br/>ח.פ / ת.ז: " + this.business_tax_id;
					}
				}

				return str;
			},
			userAddress() {
				if (this.shipping_first_name && this.shipping_last_name && this.showOtherAddress) {
					var str =
						'כתובת משלוח חד"פ' +
						"<br />" +
						this.shipping_first_name +
						" " +
						this.shipping_last_name +
						"<br />" +
						this.shipping_phone;

					if (this.shipping_phone2) {
						str = str + "<br />" + this.shipping_phone2;
					}
					str =
						str +
						"<br />" +
						this.shipping_street +
						" " +
						this.shipping_house +
						"<br />" +
						this.shipping_city;
					if (this.shipping_floor) {
						str = str + "<br />" + "קומה " + this.shipping_floor;
					}
					if (this.shipping_apart) {
						str = str + ", דירה " + this.shipping_apart;
					}
					if (this.shipping_code) {
						str = str + "<br />" + "קוד " + this.shipping_code;
					}
					return str;
				} else {
					var str = this.address_street + " " + this.address_house + "<br />" + this.address_city;
					if (this.address_floor) {
						str = str + "<br />" + "קומה " + this.address_floor;
					}
					if (this.address_apart) {
						str = str + ", דירה " + this.address_apart;
					}
					if (this.address_code) {
						str = str + "<br />" + "קוד " + this.address_code;
					}
					return str;
				}
			},
		},
		components: {
			OK,
			USERSTROKE,
			PEN,
			Select2,
			VueSimpleSuggest,
			OfficeCoreCoordinates,
			BirthdayField
		},
	};
</script>

<style lang="scss" scoped>
	.shipping-method {
		margin-bottom: 2em;

		.radio_choose {
			margin-right: 0;
			display: flex;
			flex-direction: column;
			gap: 7px;

			.form_radio {
				margin: 0 0 0 20px;

				.shipping-price span {
					color: #1e824c;
					font-weight: bold;
				}
			}
		}
	}
	.birthday-warp {
		hr {
			margin: 20px 0;
		}
	}
</style>

<style scoped>
	.autoc_tx {
		width: 100%;
	}
	.form_select a.select2-choice {
		color: black !important;
	}
	.small_rounded_button {
		background-color: #213519;
		border: 0;
		color: #fff;
		border-radius: 50%;
		margin-right: 20px;
		vertical-align: middle;
		text-align: center;
		display: inline-block;
		width: 25px;
		height: 22px;
		position: absolute;
		left: 0;
		top: 0;
		transform: translate(10px, 10px);
	}
	.misc-item {
		padding: 9px;
	}

	.loading-button {
		position: relative;
	}

	.loading-button.is-loading .loader {
		opacity: 1;
	}
	.loading-button.is-loading {
		color: transparent;
	}

	.loading-button .loader {
		position: absolute;
		top: 50%;
		left: 50%;
		margin: 0;
		transform: translate(-50%, -50%);
		height: 2rem;
		line-height: 1;
		opacity: 0;
	}

	.loading-button .loader img {
		height: 100%;
	}
	.error-not-from-list {
		font-size: 12px;
		text-align: right;
		color: #ea4724;
	}

	.no-street {
		font-size: 12px;
		text-align: right;
		color: #ea4724;
	}
</style>
